import React from 'react'
import ProdIOOExiBomRow from './ProdIOOExiBomRow'
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormLink from '../../../../../library/form/components/FormLink';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiViewContent, UiRow, UiClear } from "../../../../../library/layout/Index";

const ProdIOOExiBom = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <>
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
                action={{ formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, actionParam:{} }} contentStyle={{ height: '350px' }}
                formStyle={{ width: '710px', height: '500px' }} formTitle={<SarasTrans value="Add Stock from BOM" />}
            >
            <UiView>
                <UiRow>
                    <span className="uiLblS uiSpacerH5">
                        <FormLabel formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemId" }} value="Item ID" />:
                    </span>
                    <FormLink className="uiLink uiSpacerH15" formObject={formObject} headerKey="prodHeaderRow" linkProp={{ target: "_blank" }}
                        action={{ paramName: "itemId", actionId: "show", actionName: "itemComp" }}

                    />
                    <span className="uiLblS">
                        <FormLabel formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemName" }} value="Item Name" />:
                    </span>
                    <FormROValue formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemName" }} />
                </UiRow>
                <div className="uiSpacer10"></div>
                <UiRow>
                    <span className="uiLblS uiSpacerH5">
                    {<SarasTrans value="Select BOM" />}
                    </span>
                    <FormInput formObject={formObject} headerKey="prodHeaderRow"
                        action={{ InputType: "ac", paramName: "bomName", acMethod: "TargetItemBom", 
                        acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdtId': '%dataList.tdtId',  'tdId': '%dataList.tdId'},
                        actionParam:{} }} className='uiInput uiSpacerH10' style={{width:'300px'}}/>
                    <FormButton formObject={formObject} headerKey="prodHeaderRow"
                        action={{ refreshMode:"self", actionId: "refresh",  actionParam: {actionType: 'prepareRMFromBOM', viewKey:"addBOMItem"} }}
                        className="uiActionButton uiSpacerH10" text={<SarasTrans value="Get BOM Materials" />}></FormButton>
                </UiRow>
                <div className="uiSpacer10"></div>
                <UiClear></UiClear>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline">{<SarasTrans value="Materials" />}</span>
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Req Qty 1" /> </li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Req Qty 2" /> </li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Alloc Qty 1" /> </li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Alloc Qty 2" /> </li>
                                <li className="uiColumnCenter uiColumn60"><SarasTrans value="Action" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOExiBomRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>            
        </FormDialog>
        </>
    )
}

export default withView(ProdIOOExiBom, "prodIOAddBOM", "prodEOOutputGroup,prodIOAddBOM,prodIOPlan,prodIOSum");